export default "__VITE_ASSET__c245Gqyk__"